import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	mqttServer: 'wss://mqtt.iglor.es:10443/mqtt',
  	connected: false,
    language: 'default',
    fontSize: 16

  },
  mutations: {
  	setConnected(state){
  		state.connected = true
  	},
  	setDisconnected(state){
  		state.connected = false
  	},
    setLanguage(state,lang){
      state.language = lang
    },
    setFontSize(state,size){
      state.fontSize = size
    }
  },
  actions: {
  	setConnected(context) {
  		context.commit('setConnected')
  	},
  	setDisconnected(context) {
  		context.commit('setDisconnected')
  	},
    setLanguage(context,lang) {
      context.commit('setLanguage',lang)
    },
    setFontSize(context,size) {
      context.commit('setFontSize',size)
    }
  },
  modules: {
  }
})
